import React from 'react';
import './productsPageStyle.css';
import ProductCard from './productCard.js/productCard';
import Navbar from '../../components/navbar/navbar';
import Footer from '../../components/footer/footer';
import useSetSiteLanguage from '../../hooks/useSetSiteLanguage';
import H2Title from './../../components/text/h2Title/h2Title'

export default function ProductsPage() {

    const siteContent = useSetSiteLanguage();

    return (
      <>
        <Navbar data={siteContent?.navbar}/>
        <section className='products-page__container'>
            <H2Title title={siteContent?.productsPage?.summary?.title} />
            <div className='products-page__content-wrapper'>
              {siteContent?.productsPage?.products.map( (item, index) => (
                <ProductCard product={item} key={index}/>
              ))}
            </div>  
        </section>
        <Footer />
      </>
    );
}
